<div class="container">
    <div>
        <label>Forecast Minutes but No Agenda</label>
        <thera-client-side-list
            [columnDefs]="columnDefinitionForecast"
            [rowData]="rowDataForecast"
        >
        </thera-client-side-list>
    </div>
    <div>
        <label>Forecast Does Not Match Agenda</label>
        <thera-client-side-list
            [columnDefs]="columnDefinitionForecastAgenda"
            [rowData]="rowDataForecastAgenda"
        >
        </thera-client-side-list>
    </div>
    <div>
        <label>Patient on Agenda but Not Assigned to Therapist</label>
        <thera-client-side-list
            [columnDefs]="columnDefinitionNoTherapist"
            [rowData]="rowDataNoTherapist"
        >
        </thera-client-side-list>
    </div>
</div>